import script from "./Translate.vue?vue&type=script&lang=ts"
export * from "./Translate.vue?vue&type=script&lang=ts"

export default script